import { useContext, useEffect, useState } from 'react';
import ReactLoading from 'react-loading';
// import DetailsTabs from '../../components/detailsTabs/DetailsTabs';
import DetailsImageDisplay from '../../components/detailsImageDisplay/DetailsImageDisplay';
// import OrgTripDateTab from '../../components/orgTripDateTab/OrgTripDateTab';
// import { OrgDatesContext } from '../../context/OrgDatesContest';
import EmptyPage from '../../components/empty-page/emptyPage';
import ReviewStars from '../../components/reviewStars/ReviewStars';
import { share } from '../tripDetails/tripDetailsFun/tripDetailsShare';
import { ReactComponent as Share } from '../../assets/icons/trvto_share.svg';
import BackIcon from '../../assets/icons/trvto_ArrowBack.svg';
import { useNavigate, useParams } from 'react-router-dom';
import { standardDate } from '../../utils/formatDate';
import fetchSupOrgTripData from './supOrgTripDetailsFun/fetchSupOrgTripData';
import { SupOrgDatesContext } from '../../context/SupOrgDatesContest';
import SupOrgTripDateTab from '../../components/supTripDateTab/SupOrgTripDateTab';
import DetailsTab from '../../components/orgDetails/detailsTab/DetailsTab';

const MODE_TO_SERVICE = {
    t: 'trip',
    a: 'act',
    c: 'camp',
    g: 'guide'
};

const MODE_TO_SERVICE1 = {
    t: 'trip',
    a: 'activity',
    c: 'camp',
    g: 'guide'
};

export default function SupOrgTripDetails() {
    const navigate = useNavigate();
    const { orgId } = useParams();
    const [packData, setPackData] = useState({});
    const [loading, setLoading] = useState(false);
    const [load, setLoad] = useState(false);
    const [isExpanded, setIsExpanded] = useState(false);
    const { mode } = useParams();
    const serviceType = MODE_TO_SERVICE[mode] || 'trip';
    const refresh = () => {
        setLoad(!load);
    };
    const context = {
        role: 'support',
        flow: MODE_TO_SERVICE1[mode]
    };
    const { dates, setDates } = useContext(SupOrgDatesContext);
    const whichSection = window.location.pathname.split('/')[1];
    useEffect(() => {
        window.scrollTo({
            top: 0,
            behavior: 'smooth'
        });
    }, []);

    useEffect(() => {
        fetchSupOrgTripData(setLoading, setPackData, setDates, serviceType);
        //eslint-disable-next-line
    }, [load]);

    return (
        <div>
            {loading && (
                <div className='loadingBackground'>
                    <ReactLoading type='spin' color='#006aff' className='loadingSpin' />
                </div>
            )}
            <button className='backBtn' onClick={() => navigate(`/support/${mode}/packages/${orgId}`)}>
                <img src={BackIcon} alt='back' /> Back to Packages
            </button>
            {Object.keys(packData).length !== 0 ? (
                <>
                    <div className='orgTripDetailsLayout'>
                        <div className='tripDetailsMainRow'>
                            <div className='tripDetailsLeft'>
                                <div className='orgTripDetailsHeadingDiv'>
                                    <div className='flex'>
                                        <h1 className='detailsImageDisplayName'>{packData.title}</h1>
                                        <Share onClick={(e) => share(e)} />
                                    </div>
                                    <div>
                                        <div className='tripBriefInfo'>
                                            <span className='tripDetailsSubDetails tripDetailsOrgName'>
                                                {packData?.organizerName ?? 'N/A'}
                                            </span>
                                            <span className='tripDetailsDot'></span>
                                            <span className='tripDetailsSubDetails'>
                                                {packData?.days + 'D/' + packData?.nights + 'N'}
                                            </span>
                                            <span className='tripDetailsDot'></span>
                                            <span className='tripDetailsSubDetails'>
                                                {dates.length !== 0 && standardDate(dates[0]?.startDate?.split('T')[0])}{' '}
                                                Onwards
                                            </span>
                                            <span className='tripDetailsDot'></span>
                                            <span className='tripDetailsSubDetails'>
                                                {packData?.quickView?.startTime ?? 'N/A'}
                                            </span>
                                            <span className='tripDetailsDot'></span>
                                            <span className='tripDetailsSubDetails'>
                                                {packData?.quickView?.stay ?? 'N/A'}
                                            </span>
                                            <span className='tripDetailsDot'></span>
                                            <span className='tripDetailsSubDetails'>
                                                {packData?.quickView?.food ?? 'N/A'}
                                            </span>
                                            <span className='tripDetailsDot'></span>
                                            <span className='tripDetailsSubDetails'>
                                                {packData?.quickView?.type[0] ?? 'N/A'}
                                            </span>
                                            <span className='tripDetailsDot'></span>
                                            <span className='tripDetailsSubDetails'>
                                                {packData?.quickView?.difficulty ?? 'N/A'}
                                            </span>
                                            <span className='tripDetailsDot'></span>
                                            <span className='tripDetailsSubDetails'>
                                                <ReviewStars rating={packData?.rating} className='reviews' />
                                                <span>{packData?.rating ?? 'N/A'}</span>
                                            </span>
                                        </div>
                                    </div>
                                </div>
                                <DetailsImageDisplay imageData={packData.images} stayImages={packData?.stayDetails?.images} />
                                {/* <div
                                    className={
                                        packData.status === 'active' ? 'tripDetailsTextBooking' : 'inactiveTripTab'
                                    }
                                > */}
                                {/* <div className='tripDetailsText'> */}
                                {/* <DetailsTabs
                                    tripDetailsData={packData}
                                    isExpanded={isExpanded}
                                    setIsExpanded={setIsExpanded}
                                    refresh={refresh}
                                /> */}
                                <DetailsTab
                                    context={context}
                                    data={packData}
                                    refresh={refresh}
                                    whichSection={whichSection}
                                />
                            </div>
                            {packData.status === 'active' && (
                                <div className='tripDetailsBookingUser'>
                                    <SupOrgTripDateTab
                                        price={packData.price[0]}
                                        packData={packData}
                                        refresh={refresh}
                                        isExpanded={isExpanded}
                                        setIsExpanded={setIsExpanded}
                                        serviceType={serviceType}
                                    />
                                </div>
                            )}
                        </div>
                    </div>{' '}
                </>
            ) : (
                <EmptyPage />
            )}
        </div>
    );
}
